export default __webpack_public_path__ + "img/bpPLmdCf.659acb87.svg";